import React, { Component } from 'react'
import Prompt from './Prompt'

export default class P extends Component {
  render() {
    return <Prompt color="red" letter="P" {...this.props} />
  }
}



// WEBPACK FOOTER //
// ./src/components/Prompts/P.js